import { render, staticRenderFns } from "./PaymentResult.vue?vue&type=template&id=08d7a047&scoped=true&"
import script from "./PaymentResult.vue?vue&type=script&lang=js&"
export * from "./PaymentResult.vue?vue&type=script&lang=js&"
import style0 from "./PaymentResult.vue?vue&type=style&index=0&id=08d7a047&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7a047",
  null
  
)

component.options.__file = "PaymentResult.vue"
export default component.exports